import { motion } from "framer-motion";
import { Plane, Hotel, Ticket } from "lucide-react";
import { PASOS } from "./data";
import { Reveal, Overline } from "./Reveal";
import { ProposalExample } from "./ProposalExample";

const RESERVAS = [
  { icon: Plane, title: "Vuelos", text: "Link directo a Latam, GOL, Azul u otras aerolíneas" },
  { icon: Hotel, title: "Hoteles", text: "Link a Booking, Hotels.com o al sitio del hotel" },
  { icon: Ticket, title: "Excursiones y transfers", text: "Link al operador local o plataforma de actividades" },
];

const Reservas = () => (
  <Reveal>
    <div data-testid="reservas-block" className="mt-24 rounded-[2rem] border border-sol/25 bg-white/5 p-8 backdrop-blur sm:p-12">
      <span className="inline-block rounded-full bg-sol/15 px-4 py-1.5 text-xs font-bold text-sol">¿Cómo funcionan las reservas?</span>
      <h3 className="mt-6 font-display text-3xl font-extrabold leading-tight sm:text-5xl">Vos reservás. <span className="font-serif-i font-normal text-sol">Nosotros te guiamos.</span></h3>
      <p data-testid="reservas-text" className="mt-5 max-w-3xl text-base leading-relaxed text-arena/85 md:text-lg">
        Jaha Brasilpe diseña tu viaje, investiga las mejores opciones y te entrega los links directos a cada reserva. El pago lo hacés vos, directamente con el proveedor — sin intermediarios, sin comisiones ocultas.
      </p>
      <div className="mt-10 grid gap-4 border-t border-arena/15 pt-10 md:grid-cols-3">
        {RESERVAS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="rounded-2xl bg-white/5 p-6">
            <Icon className="h-6 w-6 text-sol" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-sol">{title}</p>
            <p className="mt-2 text-base text-arena/90">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </Reveal>
);

export const Steps = () => (
  <section id="como-funciona" data-testid="how-it-works-section" className="relative overflow-hidden bg-selva py-24 text-arena lg:py-36">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <Reveal>
        <Overline light>Cómo funciona</Overline>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl">
          Cuatro pasos entre tú y <span className="font-serif-i font-normal text-sol">la arena tibia.</span>
        </h2>
      </Reveal>
      <div className="relative mt-20">
        <motion.div className="absolute left-0 right-0 top-7 hidden h-px origin-left bg-sol/50 lg:block"
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }} />
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {PASOS.map((p, i) => (
            <Reveal key={p.n} delay={0.15 * i}>
              <div data-testid={`step-${i + 1}`} className="group">
                <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-sol font-display text-lg font-extrabold text-selva transition-transform duration-500 group-hover:scale-110">
                  {p.n}
                </span>
                <h3 className="mt-8 font-display text-2xl font-bold sm:text-3xl">{p.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-arena/80">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reservas />
      <ProposalExample />
    </div>
  </section>
);
